import { render, staticRenderFns } from "./RestrictedDates.vue?vue&type=template&id=e2753626&scoped=true&lang=pug&"
import script from "./RestrictedDates.vue?vue&type=script&lang=js&"
export * from "./RestrictedDates.vue?vue&type=script&lang=js&"
import style0 from "./RestrictedDates.vue?vue&type=style&index=0&id=e2753626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2753626",
  null
  
)

/* custom blocks */
import block0 from "./RestrictedDates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDatePicker,VDialog,VTextField})
